export default __webpack_public_path__ + "static/media/kslot_banner_highlight.20e2c4e1.png";